import { IDatasource, IGetRowsParams } from 'ag-grid-community';
import { DocketService } from '../';
import { DocketReportParams } from '../../models/docket-report-params';
import { FormGroup } from '@angular/forms';
import { map } from 'rxjs/operators';

export class DocketDataSource implements IDatasource {
  constructor(
    private docketService: DocketService,
    private values: any
  ) {}

  getRows(params: IGetRowsParams): void {
    const qsParams = {
      excludeDeleted: 1,
      limit: params.endRow,
      offset: params.startRow,
      sortBy: params.sortModel?.[0]?.colId ?? 'id',
      sortOrder: params.sortModel?.[0]?.sort ?? 'asc'
    } as any;

    this.docketService
      .generateReport(qsParams, this.values)
      .pipe(map(({ data }) => data))
      .subscribe((results) => {
        let lastRow = -1;
        if (results.length <= params.endRow) {
          lastRow = results.length + 1;
        }
        params.successCallback(results, lastRow);
      });
  }
}
